// src/components/ThucDonTuan.js
import React, { useState, useEffect, useCallback } from "react";
import { fetchData, updateData } from "../services/api";
import { useThongBao, ThongBao, docQuyen } from "../vo";

// ============================================================
// 🍚 THỰC ĐƠN TUẦN
// ------------------------------------------------------------
// Chủ nhà: "trang đi chợ hơi dư đất, có thể bố trí ở đó thực đơn tuần
// này cho cả nhà được không?"
//
// Đúng chỗ: thực đơn và đi chợ dùng CÙNG MỘT LÚC — ngồi nghĩ tuần này ăn
// gì thì biết phải mua gì. Một cái liếc mắt thay vì hai lần mở.
//
// ⚠️ ĐÂY LÀ TỜ GIẤY DÁN TỦ LẠNH, KHÔNG PHẢI BẢNG KẾ HOẠCH.
// Bảy dòng cố định, ô chữ tự do, ghi đè thoải mái. KHÔNG có nút "đã nấu",
// KHÔNG nhắc, KHÔNG lịch sử, KHÔNG gắn ngày tháng.
//
// Vì sao: thực đơn rất dễ biến thành bảng chấm điểm — Mẹ ghi "thứ Ba: cá
// kho", tối đó nấu món khác, rồi app ghi nhận "chưa hoàn thành". Thế là
// thêm một nghĩa vụ nữa, đúng thứ chân dung mục 5.1 đã đóng: app trình
// bày sự thật, app KHÔNG PHẠT. **Đừng thêm nút "đã nấu" về sau.**
//
// Không gắn ngày tháng còn tránh một chuyện thật: chủ nhật đi chợ là đi
// cho tuần SAU, mà màn hình lại hiện tuần này sắp hết.
//
// ⚠️ DongThu nằm NGOÀI hàm cha — xem bài học
// docs/bai-hoc/2026-09-07-06_ham-trong-ham-lam-mat-con-tro.md
// ============================================================

const TEN_THU = ["", "Thứ Hai", "Thứ Ba", "Thứ Tư", "Thứ Năm", "Thứ Sáu", "Thứ Bảy", "Chủ nhật"];

// getDay(): 0 = Chủ nhật … 6 = thứ Bảy. Bảng của ta: 1 = thứ Hai … 7 = Chủ nhật.
// Tính theo giờ MÁY NGƯỜI DÙNG — chỉ để tô sáng một dòng, không phải dữ liệu,
// nên không cần hỏi máy chủ.
const thuHomNay = () => {
  const d = new Date().getDay();
  return d === 0 ? 7 : d;
};

function DongThu({ thu, monAn, tenNguoiSua, laHomNay, dangSua, nhap, onDoiNhap, onMoSua, onLuu, onHuy, vietDuoc }) {
  return (
    <li className={`td-dong td-dong-thu-${thu} ${laHomNay ? "td-dong-hom-nay" : ""}`}>
      <span className="td-thu">
        {TEN_THU[thu]}
        {laHomNay && <span className="td-nhan-hom-nay"> hôm nay</span>}
      </span>

      {dangSua ? (
        <span className="td-o-sua">
          <input
            type="text"
            value={nhap}
            onChange={(e) => onDoiNhap(e.target.value)}
            placeholder="Ăn gì?"
            maxLength={300}
            className="td-o"
            autoFocus
            onKeyDown={(e) => {
              if (e.key === "Enter") onLuu();
              if (e.key === "Escape") onHuy();
            }}
          />
          <button onClick={onLuu} className="nut nut-xanh">Lưu</button>
          <button onClick={onHuy} className="nut nut-xam">Thôi</button>
        </span>
      ) : (
        <button
          type="button"
          className={`td-mon ${monAn ? "" : "td-mon-trong"}`}
          onClick={vietDuoc ? onMoSua : undefined}
          disabled={!vietDuoc}
          title={vietDuoc ? "Bấm để sửa" : undefined}
        >
          {monAn || (vietDuoc ? "— bấm để ghi —" : "—")}
          {monAn && tenNguoiSua && <span className="td-ai"> · {tenNguoiSua}</span>}
        </button>
      )}
    </li>
  );
}

function ThucDonTuan({ user }) {
  const [ds, setDs] = useState([]);
  const [dangTai, setDangTai] = useState(true);
  const [suaThu, setSuaThu] = useState(null);
  const [nhap, setNhap] = useState("");

  // Ai có quyền Thêm HOẶC Sửa thì viết được. Cố ý rộng — đây là tờ giấy
  // chung, con muốn ghi "thứ Bảy con muốn ăn bún" thì cứ ghi.
  const q = docQuyen(user);
  const vietDuoc = q.them || q.sua;

  const { bao, noiBao } = useThongBao();

  const taiLai = useCallback(async () => {
    try {
      const d = await fetchData("thuc-don");
      setDs(Array.isArray(d) ? d : []);
    } catch (err) {
      setDs([]);
    } finally {
      setDangTai(false);
    }
  }, []);

  useEffect(() => {
    taiLai();
  }, [taiLai]);

  const luu = async (thu) => {
    try {
      await updateData("thuc-don", thu, { mon_an: nhap.trim() });
      setSuaThu(null);
      setNhap("");
      await taiLai();
    } catch (err) {
      noiBao("⚠️ Không lưu được — có thể bạn chưa được cấp quyền ghi");
    }
  };

  if (dangTai || ds.length === 0) return null;

  const homNay = thuHomNay();

  return (
    <div className="td-khoi">
      <h4 className="td-tieu-de">🍚 Thực đơn tuần</h4>
      <ThongBao bao={bao} />

      <ul className="td-danh-sach">
        {ds.map((d) => (
          <DongThu
            key={d.thu}
            thu={d.thu}
            monAn={d.mon_an}
            tenNguoiSua={d.ten_nguoi_sua}
            laHomNay={d.thu === homNay}
            dangSua={suaThu === d.thu}
            nhap={nhap}
            onDoiNhap={setNhap}
            onMoSua={() => { setSuaThu(d.thu); setNhap(d.mon_an || ""); }}
            onLuu={() => luu(d.thu)}
            onHuy={() => setSuaThu(null)}
            vietDuoc={vietDuoc}
          />
        ))}
      </ul>

      <p className="td-nhac">
        Ghi đè thoải mái. Đây là tờ giấy dán tủ lạnh, không phải bảng kế hoạch —
        nấu món khác cũng chẳng sao.
      </p>
    </div>
  );
}

export default ThucDonTuan;
